export default __webpack_public_path__ + "static/CelAnimation-BG-8c7ee7e11cc04bca4aa9fcaa914661ff.jpg";